import React, { useEffect, useRef, useState } from "react";
import { Sun, Smartphone, Shield } from "lucide-react";

export default function TechSimple() {
  const [theme, setTheme] = React.useState(() => {
    return localStorage.getItem('theme') || 'dark';
  });

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  React.useEffect(() => {
    const handleStorage = () => {
      setTheme(localStorage.getItem('theme') || 'dark');
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      className={`py-16 md:py-24 px-4 transition-all duration-1000 ${
        theme === 'dark' ? 'bg-gray-900/50' : 'bg-gray-50'
      }`}
    >
      <div className="max-w-6xl mx-auto">
        <div className={`text-center transition-all duration-1000 ease-out ${
          isVisible
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-8'
        }`}>
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${
            theme === 'dark' ? 'text-white' : 'text-gray-900'
          }`}>
            Technology Meets Sun Safety
          </h2>
          <p className={`text-lg max-w-3xl mx-auto ${
            theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
          }`}>
            Combining engineering, health technology, and AI to help you make safer choices for your skin
          </p>
        </div>
      </div>
    </section>
  );
}

